<div class="flex align-center pagination-container">
	<mat-paginator
		*ngIf="totalLength > 1"
		class="ad-builder-paginator"
		[class.hide-range-label]="hideRangeLabel"
		[length]="overridePageCount ? (overridePageCount * paginationService.pageSize) : (overrideLengthWithTotal ? totalLength : length)"
		[pageSize]="paginationService.pageSize"
		[pageSizeOptions]="paginationService.pageSizeOptions"
		[pageIndex]="paginationService.currentPage-1"
		[showFirstLastButtons]="((overrideLengthWithTotal ? totalLength : length) / paginationService.pageSize) > 2"
		(page)="paginationService.updatePagination($event.pageIndex, $event.pageSize, length); paginatorChange.emit({ pageIndex: $event.pageIndex + 1, pageSize: $event.pageSize })"
	></mat-paginator>
	<!-- Zoom -->
	<app-ad-preview-zoom
		*ngIf="showZoom"
		[activeItem]="activeItem"
		[previewScale]="previewScale"
		[previewMaxHeight]="previewMaxHeight"
		(previewScaleChange)="previewScaleChange.emit($event)"
		(previewMaxHeightChange)="previewMaxHeightChange.emit($event)"
	>
	</app-ad-preview-zoom>
</div>
